import React, { useState, useEffect } from "react";
import {
  TextField,
  Paper,
  Button,
  Snackbar,
  LinearProgress,
  Typography,
  SnackbarContent,
  Box,
} from "@mui/material";
import Header from "./Header";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  forgotPassword as forgotPasswordAction,
  confirmForgotPassword as confirmForgotPasswordAction,
} from "../../actions/auth_actions";

const Forget = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [passwordcon, setPasswordcon] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const forgotPasswordCode = useSelector((state) => state.auth.forgotPasswordCode);
  const errorMessage = useSelector((state) => state.auth.error);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (errorMessage) {
      setOpen(true);
      setError(errorMessage);
      setLoading(false);
    }
  }, [errorMessage]);

  const reset = (e) => {
    e.preventDefault();

    let username = email.trim();
    let confirmationCode = code.trim();
    let newPassword = password;

    if (!forgotPasswordCode) {
      dispatch(forgotPasswordAction({ username }, navigate));
    } else {
      if (password === passwordcon) {
        dispatch(
          confirmForgotPasswordAction(
            { username, confirmationCode, newPassword },
            navigate
          )
        );
      } else {
        setError("Passwords do not match!");
        setOpen(true);
      }
    }
  };

  return (
    <Box>
      <Box sx={{ height: 5 }}>{loading && <LinearProgress />}</Box>
      <Header />
      <Paper
        sx={{
          mt: 7.5,
          width: 400,
          margin: "auto",
          pt: 2.5,
          pb: 2.5,
        }}
      >
        <Typography
          variant="h6"
          sx={{ m: 2.5, mb: 0, mt: 1.25 }}
        >
          Reset your password
        </Typography>
        {!forgotPasswordCode && (
          <Box component="form" onSubmit={reset}>
            <TextField
              id="outlined-email-input"
              label="Email"
              type="email"
              name="email"
              autoComplete="email"
              margin="normal"
              variant="outlined"
              autoFocus
              required
              onChange={(e) => setEmail(e.target.value)}
              sx={{ m: 2.5, width: 360 }}
            />
            <Button
              variant="contained"
              size="large"
              color="primary"
              type="submit"
              sx={{ m: 2.5, width: 360 }}
            >
              Reset
            </Button>
          </Box>
        )}
        {forgotPasswordCode && (
          
          <Box component="form" onSubmit={reset}>
            <Typography
              variant="subtitle2"
              sx={{ m: 2.5  }}
            >
              Check your email for a Verification Code
            </Typography>
            <TextField
              id="code"
              label="Verification Code"
              type="text"
              name="code"
              autoComplete="code"
              margin="normal"
              variant="outlined"
              autoFocus
              required
              onChange={(e) => setCode(e.target.value)}
              sx={{ m: 2.5, width: 360 }}
            />
            <TextField
              id="password"
              variant="outlined"
              autoComplete="new-password"
              type="password"
              label="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{ m: 2.5, width: 360 }}
            />
            <TextField
              id="passwordcon"
              variant="outlined"
              type="password"
              autoComplete="new-password"
              label="Confirm Password"
              value={passwordcon}
              onChange={(e) => setPasswordcon(e.target.value)}
              required
              sx={{ m: 2.5, width: 360 }}
            />
            <Button
              variant="contained"
              size="large"
              color="primary"
              type="submit"
              sx={{ m: 2.5, width: 360 }}
            >
              Send
            </Button>
          </Box>
        )}
      </Paper>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        sx={{ mt: 1.25 }}
      >
        <SnackbarContent
          aria-describedby="client-snackbar"
          message={<span id="message-id">{error}</span>}
          sx={{ backgroundColor: "error.dark" }}
        />
      </Snackbar>
    </Box>
  );
};

export default Forget;

